// Tabs do produto (PDP). No desktop, uma barra de tabs troca o painel ativo;
// no mobile, os mesmos paineis viram accordion (cabecalho clicavel por painel).
// Um unico indice ativo serve para os dois modos. Comportamento isolado, sem
// dependencias do tema; todo texto pt-BR vem do markup.

class ProductTabs extends HTMLElement {
  /** @type {HTMLButtonElement[]} */
  #tabs = [];
  /** @type {HTMLElement[]} */
  #panels = [];
  /** @type {HTMLButtonElement[]} */
  #headers = [];
  /** @type {number} */
  #active = 0;
  /** @type {MediaQueryList | null} */
  #desktop = null;

  connectedCallback() {
    this.#tabs = Array.from(this.querySelectorAll('[data-tab]'));
    this.#panels = Array.from(this.querySelectorAll('[data-panel]'));
    this.#headers = Array.from(this.querySelectorAll('[data-accordion]'));
    this.#desktop = window.matchMedia('(min-width: 750px)');

    this.#tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.#activate(Number(tab.dataset.tab)));
      tab.addEventListener('keydown', (event) => this.#onKeydown(event));
    });

    this.#headers.forEach((header) => {
      header.addEventListener('click', () => this.#toggleAccordion(Number(header.dataset.accordion)));
    });

    // Voltando ao desktop com tudo recolhido, garante uma aba ativa.
    this.#desktop.addEventListener('change', (event) => {
      if (event.matches && this.#active < 0) this.#activate(0);
    });

    this.#render();
  }

  /**
   * @param {number} index
   */
  #activate(index) {
    this.#active = index;
    this.#render();
  }

  /**
   * Accordion (mobile): abre o painel ou recolhe se ja estava aberto.
   * @param {number} index
   */
  #toggleAccordion(index) {
    this.#active = this.#active === index ? -1 : index;
    this.#render();
  }

  #render() {
    this.#tabs.forEach((tab, i) => {
      const on = i === this.#active;
      tab.setAttribute('aria-selected', `${on}`);
      tab.tabIndex = on ? 0 : -1;
    });
    this.#panels.forEach((panel, i) => {
      panel.classList.toggle('is-active', i === this.#active);
    });
    this.#headers.forEach((header, i) => {
      header.setAttribute('aria-expanded', `${i === this.#active}`);
    });
  }

  /**
   * Navegacao por teclado na barra de tabs (setas + Home/End).
   * @param {KeyboardEvent} event
   */
  #onKeydown(event) {
    const last = this.#tabs.length - 1;
    let target = -1;

    switch (event.key) {
      case 'ArrowRight':
        target = this.#active >= last ? 0 : this.#active + 1;
        break;
      case 'ArrowLeft':
        target = this.#active <= 0 ? last : this.#active - 1;
        break;
      case 'Home':
        target = 0;
        break;
      case 'End':
        target = last;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.#activate(target);
    this.#tabs[target]?.focus();
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs);
}
